// extracted by mini-css-extract-plugin
export default {"gridContainer":"Be83IX","slimGrid":"wh7rxE"};